import Router from './router';
import './App.less';

function App() {
	return (<Router />);
}

export default App;
